module.exports = __webpack_public_path__ + "static/media/conmiapp_logo.0089850f.jpeg";